module.exports = __webpack_public_path__ + "img/6.f896fa4b.png";